import { render, staticRenderFns } from "./enterpriseDetail.vue?vue&type=template&id=0e0358c8&scoped=true&"
import script from "./enterpriseDetail.vue?vue&type=script&lang=js&"
export * from "./enterpriseDetail.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseDetail.vue?vue&type=style&index=0&id=0e0358c8&scoped=true&lang=scss&"
import style1 from "./enterpriseDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0358c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0358c8')) {
      api.createRecord('0e0358c8', component.options)
    } else {
      api.reload('0e0358c8', component.options)
    }
    module.hot.accept("./enterpriseDetail.vue?vue&type=template&id=0e0358c8&scoped=true&", function () {
      api.rerender('0e0358c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/enterpriseDetail.vue"
export default component.exports